import { DropdownButton, DropdownOptions, DropdownContainer, DropdownOption, InputStyle, InputContainer, HorizontalSpaceContainer, UnitContainer, UnitBox } from './visual';
import { useState } from 'react';
import { AllUnits, Geometry, Materials, ShapeProps, Unit } from './shapeMetalList';
import { inputArray, Inputs, InputVariable } from '../App';
import './emergencyCSS.css';

//User Input -------------------------------------------------------------------------------------------------------------------------------------
type InputProps = {
    variable: string
    value: string
    onChange(value: string): void
}
export function InputField(props: InputProps) {
    return (
        <InputContainer className="datafield">
            <label className="datafield">
                <InputStyle type="number" value={props.value} required onChange={e => props.onChange(e.target.value)} />
                <span className="placeholder">{props.variable}</span>
            </label>
        </InputContainer>
    )
}

//Dropdown buttons --------------------------------------------------------------------------------------------------------------------------------
type DropdownProps = {
    object: any
    setObject: any
}
export function Dropdown(props: DropdownProps) {
    const [open, setOpen] = useState(false)
    var arrow = (open) ? "─" : "≡";
    var list = (AllUnits.dimensional.includes(props.object)) ? AllUnits.dimensional :
        (Geometry.Shapes.includes(props.object)) ? Geometry.Shapes : Materials.Metals;

    return (
        <DropdownContainer>
            <DropdownButton onClick={() => setOpen(!open)}>{props.object.Name} {arrow}</DropdownButton>
            {open && ( //conditional rendering (if dropdown is true then it renders, no need for ifs!)
                <DropdownOptions>
                    {list.map((o, i) => <DropdownOption onClick={() => { props.setObject(o); setOpen(!open) }} key={i}>{o.Name}</DropdownOption>)}
                </DropdownOptions>
            )}
        </DropdownContainer>
    )
}

//Array Maker --------------------------------------------------------------------------------------------------------------------------------
export type inputInfo = {
    variable: string
    value: number
}
export function arrayMaker(variable: string, value: string) {
    var inputData: inputInfo = {
        variable: variable,
        value: parseFloat(value)
    }
    let variableArray = inputArray.map(input => input.variable);
    if (variableArray.includes(inputData.variable) && value !== '') {
        inputArray.splice(variableArray.indexOf(inputData.variable), 1, inputData);
        console.log("testicles");
    }
    else if (value !== '') {
        inputArray.push(inputData);
        console.log("balls");
    } else {
        inputArray.splice(variableArray.indexOf(inputData.variable), 1);
        console.log("cock");
    }
}

//input displays --------------------------------------------------------------------------------------------------------------------------------
type DisplayProps = {
    dimensions: InputVariable[];
    unit: Unit;
    shape: ShapeProps;
    inputs: Inputs;
    setInputs(inputs: Inputs): void
}
export function InputsDisplay(props: DisplayProps) {
    return (
        <div>
            {props.dimensions.map((d, i) => <UnitContainer key={i}><InputField variable={d} key={i} value={props.inputs[d] ?? ""} onChange={(v) => props.setInputs({ ...props.inputs, [d]: v })} />
                <UnitBox>{(props.unit.DocConvert === "_1") ? (d === "W" && props.shape.Abreviation !== "PL") ? "kg/m" : "mm" : (d === "W" && props.shape.Abreviation !== "PL") ? "lbs/ft" : "in"}</UnitBox>
            </UnitContainer>)}
        </div>
    );
}

//answer displays --------------------------------------------------------------------------------------------------------------------------------
type AnswerProps = {
    mass: string
    cost: string
}
export function AnswersDisplay(props: AnswerProps) {

    return (<HorizontalSpaceContainer>
        {props.mass && (
            <div>
                Mass: {props.mass}
            </div>
        )}
        {props.cost && (
            <div>
                Cost: {props.cost}
            </div>
        )}
    </HorizontalSpaceContainer>);
}

//lookup Box --------------------------------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------------------------------------------
type CalcProps = {
    weight: number;
    unit: string;
}
export function DetailCalc(p: CalcProps) {
    const [inputQ, setInputQ] = useState('');
    const [inputP, setInputP] = useState('');
    let mass = p.weight * parseFloat(inputQ);
    let price = mass * parseFloat(inputP);
    return (<div>
        <HorizontalSpaceContainer>
            <InputField variable={"quantity"} value={inputQ} onChange={setInputQ} />
            <InputField variable={"Price per " + p.unit} value={inputP} onChange={setInputP} />
        </HorizontalSpaceContainer>
        <HorizontalSpaceContainer>
            {(isNaN(mass) === false) && (
                <div>
                    Total weight: <b>{mass.toLocaleString('en-US')}{p.unit}</b>
                </div>
            )}
            {(isNaN(price) === false) && (
                <div>
                    Total price: <b>${price.toLocaleString('en-US')}</b>
                </div>
            )}
        </HorizontalSpaceContainer>
    </div>)
}